import angular from "angular";

import { Ajax, Language, Role, Translations } from "@salaxy/core";
import { OnboardingService, SessionService, UiHelpers } from "../../services";

/**
 * Base controller for accountant wizard management.
 */
export class AccountantWizardController implements angular.IController {
  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = [
    "AjaxNg1",
    "OnboardingService",
    "SessionService",
    "UiHelpers",
    "$location"
  ];

  constructor(private ajax: Ajax, private onboardingService: OnboardingService, private sessionService: SessionService, private uiHelpers: UiHelpers, private $location: angular.ILocationService) {}

  /** Opens wizard as modal dialog */
  public async openAccountantWizardDialog(): Promise<any> {
    const getOrigin = () =>
      window.location.protocol +
      "//" +
      window.location.hostname +
      (window.location.port ? ":" + window.location.port : "");

    return this.onboardingService.getOnboardingData().then( () => {
      this.onboardingService.model.company.language = Translations.getLanguage() as Language;
      this.onboardingService.model.company.roles = [Role.Accountant ];
      this.onboardingService.model.signature.isProcura = false;
      this.onboardingService.model.ui.successUrl = getOrigin() + `/accountant-wizard-success?lang=${Translations.getLanguage()}&id=${this.onboardingService.model.id}#access_token=` + this.ajax.getCurrentToken();

      return this.onboardingService.save().then( () => {
        const url = getOrigin() + `/accountant-wizard-popup?lang=${Translations.getLanguage()}&id=${this.onboardingService.model.id}#access_token=` + this.ajax.getCurrentToken();
        return this.uiHelpers.showExternalDialog(this.onboardingService.model.id, url, { id: this.onboardingService.model.id }, { width: 1080, height: 800 }).then((result) => {
          if (result?.action != "cancel") {
            return this.sessionService.checkSession();
          } else {
            return;
          }
        });
      });
    });
  }

  /** Launches company wizard. */
  public launchAccountantWizard() {
    const data =  this.readTokenFromUrl(this.$location.absUrl(), "data=");
    if (data) {
      const id = JSON.parse(atob(decodeURIComponent(data)))?.id;
      if (id) {
        return this.onboardingService.launchCompanyOnboarding(id);
      }
    }
  }

  private readTokenFromUrl(url: string, key: string): string {
    const start = url.toLowerCase().indexOf(key);
    if (start >= 0) {
      const end = url.indexOf("&", start);
      return end >= 0
        ? url.substring(start + key.length, end)
        : url.substring(start + key.length);
    }
    return null;
  }
}